import { render, staticRenderFns } from "./WpCollection.vue?vue&type=template&id=75a8aabf&scoped=true&"
import script from "./WpCollection.vue?vue&type=script&lang=js&"
export * from "./WpCollection.vue?vue&type=script&lang=js&"
import style0 from "./WpCollection.vue?vue&type=style&index=0&id=75a8aabf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a8aabf",
  null
  
)

export default component.exports